module.exports = __webpack_public_path__ + "static/hagley-road-line.906a15fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ThePlatform/hagley-road-line.png
// module id = 457
// module chunks = 145206920446059